/** Canonical finance partner id for grid rows, opportunity products, and pre-contract. */
export function normalizeFinanceGridPartner(partner: string): string {
    const lower = (partner || '').toLowerCase();
    if (lower.includes('good') && lower.includes('leap')) return 'GoodLeap';
    if (lower.includes('light') && lower.includes('reach')) return 'LightReach';
    if (lower === 'igs' || lower === 'ics') return 'IGS';
    if (lower.includes('enfin')) return 'Enfin';
    if (lower.includes('cash')) return 'Cash';
    return partner || 'Unknown';
}

/** Alias used by FinancingGridCard and pre-contract pricing. */
export const normalizePartner = normalizeFinanceGridPartner;

export function financePartnerKeysEqual(
    a: string | null | undefined,
    b: string | null | undefined,
): boolean {
    const left = normalizeFinanceGridPartner(String(a ?? '')).toLowerCase().replace(/\s+/g, '');
    const right = normalizeFinanceGridPartner(String(b ?? '')).toLowerCase().replace(/\s+/g, '');
    if (!left || !right) return false;
    return left === right;
}

export function financePartnerNormLower(partner: string): string {
    return normalizeFinanceGridPartner(partner).toLowerCase();
}
